import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { api } from "../api";
import { ExerciseGrid } from "../ExerciseCard";
import { useFavToggle } from "./Library";
import { H1, Overline, PageLoader } from "../ui";

export default function Favorites() {
  const [items, setItems] = useState(null);
  const toggle = useFavToggle(setItems);
  useEffect(() => { api("/me/favorites").then((d) => setItems(d.items)).catch((e) => toast.error(e.message)); }, []);
  const onFav = async (ex) => { await toggle(ex); setItems((l) => l.filter((x) => x.exercise_id !== ex.exercise_id)); };
  return (
    <div data-testid="favorites-page">
      <Overline className="mb-3">Deine Sammlung</Overline>
      <H1 className="mb-10 !text-5xl sm:!text-6xl">Favoriten</H1>
      {!items ? <PageLoader /> : items.length ? <ExerciseGrid items={items} onFav={onFav} testId="favorites-grid" /> : (
        <div className="border border-dashed border-white/15 p-12 text-center" data-testid="favorites-empty">
          <Heart className="w-8 h-8 text-[#71717A] mx-auto mb-4" />
          <p className="text-[#A1A1AA] mb-4">Noch keine Favoriten. Tippe in der Bibliothek auf das Herz.</p>
          <Link to="/training/bibliothek" className="text-[#c1ff72] underline">Zur Bibliothek</Link>
        </div>
      )}
    </div>
  );
}
